import {
  base_colorAction,
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_semibold } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: block;
  /* Keeps a tile clear of the fixed global header + pinned card bar when it is
     the target of a #fragment deep link. Inert for every tile that is not
     linked to, since nothing scrolls to those. */
  scroll-margin-top: ${spacing(30)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(3)};
  background-color: ${base_colorRaisedSurface};
  padding: ${spacing(5)} ${spacing(6)};

  /* Rubik faces are registered at font-weight: normal, so the browser's default
     <h3> { font-weight: bold } would layer a synthetic bold on top of
     Rubik-Semibold — pin it to normal and let the family carry the weight. */
  .SettingsTile-kicker {
    margin: 0 0 ${spacing(4)};
    font-family: ${font_family_weight_semibold};
    font-weight: normal;
    font-size: 11.5px;
    line-height: 16px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${text_colorTextSecondary};
  }

  /*
    The "you are here" pulse for a tile arrived at by #fragment deep link —
    today, "Adjust limit" from the card hero's ••• menu or the Overview roll-up
    (EX-40599). Set imperatively by AccountEntityPage, which owns the hash.

    A ring rather than a persistent border change: the tile has to look normal
    the moment the animation ends, and animating box-shadow + background costs
    no layout. Timings come from the card-management design prototype — the ring
    reaches full strength at 12% of a 1.9s curve, then decays.
  */
  @keyframes settingsTileAnchorFlash {
    0% {
      box-shadow: 0 0 0 3px transparent;
      background-color: ${base_colorRaisedSurface};
    }
    12% {
      box-shadow: 0 0 0 3px
        color-mix(in srgb, ${base_colorAction} 45%, transparent);
      background-color: color-mix(
        in srgb,
        ${base_colorAction} 5%,
        ${base_colorRaisedSurface}
      );
    }
    100% {
      box-shadow: 0 0 0 3px transparent;
      background-color: ${base_colorRaisedSurface};
    }
  }

  &[data-anchor-highlight='true'] {
    animation: settingsTileAnchorFlash 1.9s ease-out;
  }

  /*
    Reduced motion keeps the signal and drops the animation: the ring is the
    only thing telling the user why the page jumped, so it is held static for
    the same duration rather than removed. The page clears the attribute on the
    same timer either way.
  */
  @media (prefers-reduced-motion: reduce) {
    &[data-anchor-highlight='true'] {
      animation: none;
      box-shadow: 0 0 0 3px
        color-mix(in srgb, ${base_colorAction} 45%, transparent);
    }
  }
`
